import { get } from 'lodash';
import React from 'react';
import { ANTRAGS_ERFASSUNG_ART } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { isTrue } from 'src/utils/helper';
import { checkIfProjektDatenHasComment } from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import ProjektDatenSkizzeStipendium, { getFormStrucProjektDatenSkizzeStipendium } from './content/ProjektDatenSkizzeStipendium';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

export const TreeStructureSkizzeStipendium = (application: any, readOnly: boolean): TreeNodeType[] => {
	let treeNodes: TreeNodeType[] = [];

	const externeSkizze = get(application, P.Allgemein_Erfassungsart.path, '') === ANTRAGS_ERFASSUNG_ART.Manuell;

	const hasCommentProjektdaten = checkIfProjektDatenHasComment(readOnly, application);

	if (isTrue(externeSkizze)) {
		treeNodes = [
			// Allgemeinen Hinweis Global
			...TreeStructureAllgemeinHinweisGlobal(application),
			// Projektdaten
			{
				label: 'Projektdaten',
				content: <ProjektDatenSkizzeStipendium hasComment={hasCommentProjektdaten} />,
				formStruc: getFormStrucProjektDatenSkizzeStipendium(application),
				hasComment: hasCommentProjektdaten,
			},
			// Abschluss Global
			...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
		];
	}

	return treeNodes;
};
